import { Loader } from '@googlemaps/js-api-loader';
import axios from 'axios';

export function init(apiBase, apiKey) {

	if (document.querySelector('#store-finder-map')) {

		const urlParams = new URLSearchParams(window.location.search);
		const preSearchProduct = urlParams.has('pr') ? urlParams.get('pr') : '';
		const preSearchRange = urlParams.has('ra') ? urlParams.get('ra') : '';
		const preSearchLocation = urlParams.has('location') ? urlParams.get('location') : '';

		if (document.querySelector('#product-search')) {
			document.querySelector('#product-search').value = preSearchProduct + '|' + preSearchRange;
		}

		const bookDemoText = document.querySelector('#store-finder-map').getAttribute('data-bookdemotext');
		const moreInfoText = document.querySelector('#store-finder-map').getAttribute('data-moreinfotext');

		let ciSearch;
		if (document.querySelector('#store-finder-map').getAttribute('data-ci') == 'true') {
			ciSearch = true;		

		}
	
		let map;
		let infoWindow;
		let geoCoder;
		let markers = [];

		const loader = new Loader({
			apiKey: apiKey,
			version: 'weekly',
			libraries: ['places']
		});

		loader.load().then(() => {

			const userlat = parseFloat(document.querySelector('.geo-information .latitude').innerText);
			const userlng = parseFloat(document.querySelector('.geo-information .longitude').innerText);

			map = new google.maps.Map(document.getElementById('store-finder-map'), {
				center: { lat: userlat, lng: userlng },
				zoom: 7,
			});

			geoCoder = new google.maps.Geocoder();

			infoWindow = new google.maps.InfoWindow();

			let searchParams = {
				ci: ciSearch,
				product: preSearchProduct,
				range: preSearchRange
			}

			if (!ciSearch) {
				searchParams.linnSpecialist = true;
			}

			axios({
				method: 'get',
				url: apiBase + 'retailers',
				params: searchParams
			})
				.then(function (response) {

					const pathBase = document.querySelector('link[rel="home"]').getAttribute('href');
					let productSearchQueries = ['', ''];
					if (document.querySelector('#product-search')) {
					productSearchQueries = document.querySelector('#product-search').value.split('|');
					}
					const searchString = document.querySelector('form.location-search input[name="search"]').value;

					response.data.forEach((retailer) => {
						addMarkerToMap(retailer, map, markers, infoWindow, ciSearch, pathBase, bookDemoText, moreInfoText, searchString, productSearchQueries);
					});

					document.querySelector('.loading-overlay').classList.add('-hidden');

					if (preSearchLocation !== '') {
						document.getElementById('location-search').value = preSearchLocation;
						document.querySelector('form.location-search input[type="submit"]').click();
					}

				})
				.catch(function (response) {
					console.log(response);
				});

		});

		// Handle search form submission

		document.querySelector('form.location-search').addEventListener('submit', function (e) {
			e.preventDefault();

			document.querySelector('.reset').classList.add('-visible');

			markers.forEach((m) => m.setMap(null));
			markers = [];

			document.querySelector('.loading-overlay').classList.remove('-hidden');

			const searchResultsElement = document.querySelector('.search-results');
			searchResultsElement.innerHTML = '';

			let productSearchQueries = [];
			if (document.querySelector('#product-search')) {
				productSearchQueries = document.querySelector('#product-search').value.split('|');
			}

			const searchString = document.querySelector('form.location-search input[name="search"]').value;
			const request = {
				query: searchString,
				fields: ['name', 'geometry', 'types', 'place_id']
			};

			// Get details on the place from Google Places API
			const service = new google.maps.places.PlacesService(map);
			service.findPlaceFromQuery(request, function (results, status) {

				if (status === google.maps.places.PlacesServiceStatus.OK) {

					let countryCode = '';
					if (results[0].types[0] === "country") {
						geoCoder.geocode({ placeId: results[0].place_id }, (results, status) => {
							if (status === "OK") {
								if (results[0]) {
									countryCode = results[0].address_components[0].short_name;
									updateMap();
								} else {
									updateMap();
								}
							} else {
								updateMap();
							}
						})
					} else {
						updateMap();
					}

					function updateMap() {

						// Jump to the most likely place
						map.setCenter(results[0].geometry.location);
						const bounds = new google.maps.LatLngBounds(
							results[0].geometry.viewport.getSouthWest(),
							results[0].geometry.viewport.getNorthEast()
						);
						map.fitBounds(bounds);

						let searchParams;
						if (countryCode) {
							searchParams = {
								country: countryCode,
								ci: ciSearch,
								lat: results[0].geometry.location.lat(),
								lng: results[0].geometry.location.lng(),
								product: productSearchQueries[0],
								range: productSearchQueries[1]
							};
						} else {
							searchParams = {
								northlat: map.getBounds().getNorthEast().lat(),
								eastlng: map.getBounds().getNorthEast().lng(),
								southlat: map.getBounds().getSouthWest().lat(),
								westlng: map.getBounds().getSouthWest().lng(),
								lat: results[0].geometry.location.lat(),
								lng: results[0].geometry.location.lng(),
								ci: ciSearch,
								product: productSearchQueries[0],
								range: productSearchQueries[1]
							};
						}

						if (!ciSearch) {
							searchParams.linnSpecialist = true;							
							fbq('trackCustom', 'SearchRetailerFinderMap', { location: searchString, product: searchParams.product, range: searchParams.range });
						}
						else{							
							fbq('trackCustom', 'SearchCIFinderMap', { location: searchString});
						}

						// Get list of stores from Linn API
						axios({
							method: 'get',
							url: apiBase + 'retailers',
							params: searchParams,
						})
							.then(function (response) {

								const numResults = response.data.length;
								// console.log(numResults);

								const pathBase = document.querySelector('link[rel="home"]').getAttribute('href');
								let productSearchQueries = ['', ''];
								if (document.querySelector('#product-search')) {
								productSearchQueries = document.querySelector('#product-search').value.split('|');
								}

								response.data.forEach((retailer) => {

									addMarkerToMap(retailer, map, markers, infoWindow, ciSearch, pathBase, bookDemoText, moreInfoText, searchString, productSearchQueries);

									const newRow = document.createElement('div');
									newRow.classList.add('retailer');
									newRow.setAttribute('data-id', retailer.id);
									
									newRow.innerHTML = `<div class="icon"><img src="/assets/dist/img/icon-map-pin.png"></div><div class="content"><h4>${retailer.name}</h4><p class="address">${buildAddressString(retailer.address)}</p></div>`;
									searchResultsElement.appendChild(newRow);

									newRow.addEventListener('click', (e) => {
										window.location = `${pathBase}try-linn/${retailer.id}?s=${searchString}&pr=${productSearchQueries[0]}&ra=${productSearchQueries[1]}#book`;
										// const id = e.target.getAttribute('data-id');
										// google.maps.event.trigger(markers[id], 'click');
									});

								});

								function enoughThingsInBounds(require) {
									let thingsInBounds = 0;
									markers.forEach(function (marker) {
										if (map.getBounds().contains(marker.getPosition())) {
											thingsInBounds++;
										}
									});
									if (thingsInBounds >= require) {
										return true;
									} else {
										return false;
									}
								}

								if (numResults > 1) {

									while (!enoughThingsInBounds(2)) {
										map.setZoom(map.getZoom() - 1);
									}

								} else {

									while (!enoughThingsInBounds(1)) {
										map.setZoom(map.getZoom() - 1);
									}

								}

								document.querySelector('.loading-overlay').classList.add('-hidden');
							})
							.catch(function (response) {
								console.log(response);
							});

					}

				}
			});
		});
	}
}

// Convert address data from API into HTML output
function buildAddressString(address, lineBreaks = false) {
	let addressString = address.line1;
	const separator = lineBreaks ? '<br>' : ', ';
	if (address.line2) addressString += separator + address.line2;
	if (address.line3) addressString += separator + address.line3;
	if (address.line4) addressString += separator + address.line4;
	if (address.postcode) addressString += separator + address.postcode;
	return addressString;
}

// This reusable function adds a marker to the map based on 'retailer' data from API
function addMarkerToMap(retailer, map, markers, infoWindow, ciSearch, pathBase, bookDemoText, moreInfoText, searchTerm, productSearchQueries) {
	if (retailer.geocode) {
		const marker = new google.maps.Marker({
			position: { lat: retailer.geocode.latitude, lng: retailer.geocode.longitude },
			map: map,
			icon: 'https://' + window.location.hostname + '/assets/dist/img/icon-map-pin.svg'
		});

		markers[retailer.id] = marker;

		let thumbnailMarkup = '<img src="/assets/dist/img/map-thumbnail-fallback.png">';
		retailer.links.forEach((link) => {
			if (link.rel === 'map-popup') {
				thumbnailMarkup = `<img src="${link.href}">`;
			}
		});

		marker.addListener('click', () => {
			infoWindow.close();

			let infoWindowContent = `<div class="info-window" ><div class="image">${thumbnailMarkup}</div><div class="content"><h4>${retailer.name}</h4><p class="address">${buildAddressString(retailer.address, true)}</p>`;

			// if (pathBase.includes('http')) { pathBase = '/'; }

			if (ciSearch) {
				infoWindowContent += `<a href="${pathBase}whole-home/find-an-installer/${retailer.id}?s=${searchTerm}" class="btn -outline">${moreInfoText}</a>`;
			} else {
				
				
				infoWindowContent += `<a href="${pathBase}try-linn/${retailer.id}?s=${searchTerm}&pr=${productSearchQueries[0]}&ra=${productSearchQueries[1]}#book" class="btn">${bookDemoText}</a>`;
				infoWindowContent += `<a href="${pathBase}try-linn/${retailer.id}?s=${searchTerm}&pr=${productSearchQueries[0]}&ra=${productSearchQueries[1]}" class="btn -outline">${moreInfoText}</a>`;
			}

			infoWindowContent += `</div></div>`;

			infoWindow.setContent(infoWindowContent);
			infoWindow.open(map, marker);
		});
	}
}
